__turbopack_context__.v({
  "component": "style-module-scss-module__qtLR2G__component",
  "provider-logo": "style-module-scss-module__qtLR2G__provider-logo",
  "wrapper": "style-module-scss-module__qtLR2G__wrapper",
  "wrapper-small": "style-module-scss-module__qtLR2G__wrapper-small",
});
